/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.graph-title[_ngcontent-%COMP%]{font-family:johnston;font-weight:700;padding:0 0 0 30px;font-size:30px;margin:0 0 10px}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2FwcC9DbGllbnRBcHAvYXBwL3BhZ2VzL19zaGFyZWQvbGluZS1jaGFydC9saW5lLWNoYXJ0LmNvbXBvbmVudC5jc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vYXBwL0NsaWVudEFwcC9hcHAvcGFnZXMvX3NoYXJlZC9saW5lLWNoYXJ0L2xpbmUtY2hhcnQuY29tcG9uZW50LmNzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// ./$$_gendir/ClientApp/app/pages/_shared/line-chart/line-chart.component.css.shim.ngstyle.ts